import React, { useEffect, useState } from "react";
import * as API from "../../utils/api.service";
import { TOAST_ERROR } from "../../utils/common.service";
import { useParams } from "react-router-dom";
import { useDispatch} from "react-redux";
import { setLoader } from "../../Store/slices/MasterSlice";

const FAQ = () => {
  const [faqList, setFaqList] = useState([]);
  const { lang } = useParams();
  let dispatch = useDispatch();
  //console.log("lang :", lang);

  useEffect(() => {
    const fetchFaqList = async () => {
      try {
        dispatch(setLoader(true))
        const response = await API.getFaqListApi({type:"User"});
        if (response?.code === "1") {
          dispatch(setLoader(false))
          setFaqList(response?.data || []);
        } else {
          dispatch(setLoader(false))
          TOAST_ERROR("Failed to load FAQ list");
        }
      } catch (error) {
        TOAST_ERROR("Failed to load FAQ list");
      }
    };

    fetchFaqList();
  }, []);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="content">
              <h1 className="d-flex justify-content-center mt-3 mb-3">
                {lang === "ar"
                  ? "الأسئلة المتداولة"
                  : "Frequently Asked Questions"}
              </h1>
              <div
                className="accordion"
                id="faqAccordion"
                dir={lang === "ar" ? "rtl" : "ltr"}
              >
                {faqList.length > 0 ? (
                  faqList.map((faq, index) => (
                    <div className="accordion-item" key={faq.id}>
                      <h2 className="accordion-header" id={`heading${faq.id}`}>
                        <button
                          className={`accordion-button`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${faq.id}`}
                          aria-expanded="true"
                          aria-controls={`collapse${faq.id}`}
                        >
                          {lang === "ar"
                            ? `السؤال ${index + 1}: ${faq.ar_question}`
                            : `Question ${index + 1}: ${faq.question}`}
                        </button>
                      </h2>
                      <div
                        id={`collapse${faq.id}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading${faq.id}`}
                        data-bs-parent="#faqAccordion"
                      >
                        <div
                          className="accordion-body"
                        >
                          {lang === "ar"
                            ? `الإجابة: ${faq.ar_answer}`
                            : `ANS: ${faq.answer}`}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No FAQs found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
